import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationStart } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, Facet, FacetValue, SearchCriteria, FacetSearchCriteria, FacetRenderMode, AppBuildInfo } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';


@Component({
  selector: 'admin-about',
  templateUrl: './admin-about.component.html',
  styleUrls: ['./admin-about.component.css']
})

export class AdminAboutComponent implements OnInit {

  constructor(private facetedSearchAppService: FacetedSearchAppService, private router: Router) {
  }

  public appBuildInfo: AppBuildInfo

  ngOnInit(): void {
    this.router.events
      .subscribe((event) => {
        // example: NavigationStart, RoutesRecognized, NavigationEnd
        if (event instanceof NavigationStart) {

        }
      });
    this.facetedSearchAppService.appBuildInfo.then(result => { this.appBuildInfo = result;})
  }

}





// WEBPACK FOOTER //
// ./src/app/fsapplication/admin-about/admin-about.component.ts